var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_37)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 16C3.6 16 0 12.4 0 8C0 3.6 3.6 0 8 0C12.4 0 16 3.6 16 8C16 12.4 12.4 16 8 16ZM8 1.33333C4.33333 1.33333 1.33333 4.33333 1.33333 8C1.33333 11.6667 4.33333 14.6667 8 14.6667C11.6667 14.6667 14.6667 11.6667 14.6667 8C14.6667 4.33333 11.6667 1.33333 8 1.33333Z",
    fill: "#FE8900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99998 10.6667C7.59998 10.6667 7.33331 10.4 7.33331 10V9.53333C7.33331 8.53334 7.86665 7.66667 8.66665 7.2C9.19998 6.93333 9.46665 6.33333 9.33331 5.8C9.26665 5.26667 8.79998 4.8 8.26665 4.73333C7.86665 4.66667 7.46665 4.73333 7.13331 5C6.86665 5.2 6.66665 5.6 6.66665 6C6.66665 6.4 6.39998 6.66667 5.99998 6.66667C5.59998 6.66667 5.33331 6.4 5.33331 6C5.33331 5.2 5.66665 4.46667 6.26665 3.93333C6.86665 3.4 7.66665 3.2 8.46665 3.33333C9.53331 3.53333 10.4 4.4 10.6 5.46667C10.8 6.6 10.2666 7.73333 9.26665 8.26667C8.86665 8.46667 8.66665 8.93333 8.66665 9.46667V10C8.66665 10.4 8.39998 10.6667 7.99998 10.6667Z",
    fill: "#FE8900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99998 12.6667C8.36817 12.6667 8.66665 12.3682 8.66665 12C8.66665 11.6318 8.36817 11.3333 7.99998 11.3333C7.63179 11.3333 7.33331 11.6318 7.33331 12C7.33331 12.3682 7.63179 12.6667 7.99998 12.6667Z",
    fill: "#FE8900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 13C7.46667 13 7 12.5333 7 12C7 11.4667 7.46667 11 8 11C8.53333 11 9 11.4667 9 12C9 12.5333 8.53333 13 8 13ZM8 11.6667C7.8 11.6667 7.66667 11.8 7.66667 12C7.66667 12.2 7.8 12.3333 8 12.3333C8.2 12.3333 8.33333 12.2 8.33333 12C8.33333 11.8 8.2 11.6667 8 11.6667Z",
    fill: "#FE8900"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_37"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.7e19823ad4ac61f750a537b958b4f414.svg";
export { ForwardRef as ReactComponent };